import DropdownItem from './dropdown-item.component.js';

export default DropdownItem;
